import { initGiftPurchaseAttribution, giftPurchaseProperties } from './gift-purchase-attribution.js?v=e206560ce9a1468d3064ad963a6b42856e6d465a64352985a00b8f0d9342ce73';
const STORAGE_KEY = 'sigma:pending-purchase-source';
const RELATED_PRODUCTS_SOURCE = 'related_products';
const SEARCH_SOURCE = 'search';
const GIFT_FINDER_SOURCE = 'gift_finder';

function readPendingSource() {
  let serializedSource;

  try {
    serializedSource = sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }

  if (!serializedSource) return null;

  try {
    return JSON.parse(serializedSource);
  } catch {
    return null;
  }
}

function consumePendingSource() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
    return true;
  } catch {
    return false;
  }
}

function getOrCreatePropertyInput(productForm, propertyName) {
  let input = productForm.querySelector(`input[name="properties[${propertyName}]"]`);

  if (!input) {
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = `properties[${propertyName}]`;
    productForm.append(input);
  }

  return input;
}

function applyPendingSource() {
  if (giftPurchaseProperties()._sigma_purchase_source) {
    consumePendingSource();
    return;
  }
  const productForm = document.querySelector('form[id^="coffee-product-form-"], form[id^="gift-card-product-form-"]');
  if (!productForm) return;

  const pendingSource = readPendingSource();
  if (!consumePendingSource()) return;

  if (!pendingSource || pendingSource.path !== window.location.pathname) return;

  if (pendingSource.source === RELATED_PRODUCTS_SOURCE || pendingSource.source === GIFT_FINDER_SOURCE) {
    getOrCreatePropertyInput(productForm, '_sigma_purchase_source').value = pendingSource.source;
    productForm.querySelector('input[name="properties[_sigma_search_term]"]')?.remove();
    return;
  }

  if (pendingSource.source !== SEARCH_SOURCE || typeof pendingSource.searchTerm !== 'string') return;

  const searchTerm = pendingSource.searchTerm;
  if (!searchTerm.trim()) return;

  getOrCreatePropertyInput(productForm, '_sigma_purchase_source').value = SEARCH_SOURCE;
  getOrCreatePropertyInput(productForm, '_sigma_search_term').value = searchTerm;
}

function rememberProductNavigation(event) {
  if (
    event.defaultPrevented ||
    event.button !== 0 ||
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey
  ) {
    return;
  }

  if (!(event.target instanceof Element)) return;

  const link = event.target.closest('a[data-sigma-purchase-source]');
  if (!link) return;

  const source = link.dataset.sigmaPurchaseSource;
  if (source !== RELATED_PRODUCTS_SOURCE && source !== SEARCH_SOURCE && source !== GIFT_FINDER_SOURCE) return;

  const target = link.getAttribute('target');
  if (target && target.toLowerCase() !== '_self') return;
  if (link.hasAttribute('download')) return;

  let destination;

  try {
    destination = new URL(link.href, window.location.href);
  } catch {
    return;
  }

  if (destination.origin !== window.location.origin) return;

  const pendingSource = {
    path: destination.pathname,
    source,
  };

  if (source === SEARCH_SOURCE) {
    const searchTerm = link.dataset.sigmaSearchTerm;
    if (!searchTerm?.trim()) return;
    pendingSource.searchTerm = searchTerm;
  }

  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(pendingSource));
  } catch {
    // Storage can be unavailable in restricted browser modes.
  }
}

applyPendingSource();
document.addEventListener('click', rememberProductNavigation, true);

initGiftPurchaseAttribution();
